import React, { useState } from "react";
import {
  Form,
  Col,
  Row,
  Card,
  Typography,
  Input,
  Table,
  InputNumber,
  Select,
} from "antd";
import appStatic from "../../../../config/appStatic";
import ChartTable from "./ChartTable";
import { BOM } from "../../../../services/definedMethod";
import { labelConfig, staticConfig } from "../../../customer/customer.config";

const { Text } = Typography;

export const InterestRateChart = (props) => {
  const { interestRateTableSource, fixedDepositDetails } = props;

  const columns = [
    {
      title: "Period Type",
      dataIndex: "periodType",
    },
    {
      title: "Period From",
      dataIndex: "fromPeriod",
    },
    {
      title: "Period To",
      dataIndex: "toPeriod",
    },
    {
      title: "Amount Range From",
      dataIndex: "amountRangeFrom",
    },
    {
      title: "Amount Range To",
      dataIndex: "amountRangeTo",
    },
    {
      title: "Interest",
      dataIndex: "annualInterestRate",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
  ];

  return (
    <>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Valid Start Date</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  BOM.FormatArrayDate(
                    fixedDepositDetails?.activeChart?.fromDate
                  ) || "--"
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>End Date</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  BOM.FormatArrayDate(
                    fixedDepositDetails?.activeChart?.endDate
                  ) || "--"
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Is Primary Grouping By Amount</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  fixedDepositDetails?.activeChart?.isPrimaryGroupingByAmount
                    ? "Yes"
                    : "No"
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={`${labelConfig.enableManualInterestEntry}?`}>
              <Select
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase()
                  )
                }
                value={
                  fixedDepositDetails?.activeChart?.enableManualInterestEntry
                }
                options={staticConfig.yesOrNo}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label="Minimum Interest Rate"
              rules={[
                {
                  required: true,
                  message: "Minimum interest rate is required",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                max={100}
                step={0.01}
                addonAfter="%"
                value={
                  fixedDepositDetails?.activeChart?.minimumManualInterestAmount
                }
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label="Maximum Interest Rate"
              rules={[
                {
                  required: true,
                  message: "Maximum interest rate is required",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Enter maximum interest rate"
                min={0}
                max={100}
                step={0.01}
                addonAfter="%"
                value={
                  fixedDepositDetails?.activeChart?.maximumManualInterestAmount
                }
                disabled
              />
            </Form.Item>
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={interestRateTableSource}
          rowKey="id"
          bordered
          pagination={{
            position: "bottomCentre",
            pageSize: "10",
          }}
        />
      </Card>
    </>
  );
};
